import script from "./select-country.vue?vue&type=script&setup=true&lang=ts"
export * from "./select-country.vue?vue&type=script&setup=true&lang=ts"

import "./select-country.vue?vue&type=style&index=0&id=2b77d1a5&lang=less"

const __exports__ = script;

export default __exports__